import React from 'react';

export default class Gallery extends React.Component {

  render() {

    const { apiRoot, gallery_images } = this.props

    const gallery = gallery_images.map((img) =>
      <a data-lightbox="gallery" href={apiRoot + img.image.large.url}>
        <img className="gallery_image" alt="gallery_image" src={apiRoot + img.image.small.url} />
      </a>
    )

    return gallery_images[0] ? <div className="gallery">{gallery}</div> : null
  }
}
